import { State } from '../@types';
import { getPhoneCodeByCountry } from '../helpers/phoneHelpers';

export const selectMapContent = (store: State) => store.ui.map.content;

export const selectMapBoundaries = (store: State) => store.ui.map.mapBoundaries;

export const selectSelectedCar = (store: State) => store.ui.map.selectedCar;

export const selectIsCarOpened = (store: State) => store.ui.map.opened;

export const selectPhone = (store: State) => store.ui.firstSteps.phone;

export const selectPhoneNumber = (store: State) =>
  store.ui.firstSteps.phone.phoneNumber;

export const selectPhoneCodes = (store: State) => {
  const codes = store.ui.firstSteps.phoneCodes;
  if (codes && codes.length > 0) {
    return codes;
  }

  const allowed =
    store?.appData?.common?.brandSettings?.allowedPhoneNumberCountries;

  if (allowed && allowed.length > 0) {
    return allowed.map((country) => ({
      country: country.toUpperCase(),
      code: getPhoneCodeByCountry(country.toUpperCase()),
    }));
  }

  return [];
};

export const selectAddress = (store: State) => store.ui.firstSteps.address;

export const selectIsVerifyingGDPREmail = (store: State) =>
  store.ui.firstSteps.isVerifyingGDPREmail;

export const selectIsEditingPhone = (store: State) =>
  store.ui.firstSteps.isEditingPhone;

export const selectDateOfBirth = (store: State) =>
  store.ui.firstSteps.dateOfBirth;

export const selectIban = (store: State) => store.ui.firstSteps.iban;

export const selectBillingInfo = (store: State) =>
  store.ui.firstSteps.billingInfo;

export const selectTrueLayerBankAccount = (store: State) =>
  store.ui.firstSteps.trueLayerBankAccount;

export const selectBIC = (store: State) => store.ui.firstSteps.bic;

export const selectCardState = (store: State) => store.ui.map.cardState;

export const selectDefaultTab = (store: State) => store.ui.map.defaultTab;

export const selectShowHomeWT = (store: State) => store.ui.map.showHomeWT;

export const selectShowBubMigrationModal = (store: State) =>
  store.ui.map.showBubMigrationModal;

export const selectShowUbqShutdownModal = (store: State) =>
  store.ui.map.showUbqShutdownModal;

export const selectShowUserLocation = (store: State) =>
  store.ui.map.showUserLocation;

export const selectUserAddress = (store: State) => store.ui.map.userAddress;

export const selectDeeplink = (store: State) => store.ui.deeplink.deeplinkUrl;

export const selectIsFirstRental = (store: State) => store.ui.map.isFirstRental;

export const selectVisibleRegion = (store: State) => store.ui.map.visibleRegion;

export const selectIsEmbedded = (store: State) => store.ui.map.isEmbedded;

export const selectNewDamages = (store: State) => store.ui.damages.newDamages;

export const selectShowExternalBrowserScreen = (store: State) =>
  store.ui.firstSteps.showExternalBrowserScreen;

export const selectActiveAlert = (store: State) => store.ui.map.activeAlert;

export const selectAlertBaseMode = (store: State) => store.ui.map.alertBaseMode;
export const selectMapOpened = (store: State) => store.ui.map.opened;

export const selectCircleCode = (store: State) =>
  store.ui.firstSteps.circleCode;

export const selectMapFilter = (store: State) => store.ui.map.mapFilter;
